/* eslint-disable */
import React, { useEffect, useState, useCallback } from 'react'
import * as _ from 'lodash'
import DocumentTitle from 'react-document-title'
import { useHistory, useLocation } from 'react-router-dom'
import { Controller, useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

// @Components
import AddressData from './components/AddressData'
import AccessData from './components/AccessData/index.js'
import Button from 'components/CustomButtons/Button.jsx'
import ContactData from './components/ContactData'
import Header from './components/Header'
import Loader from 'components/Loader/Loader.jsx'
import IndicationData from './components/IndicationData'
import PersonalData from './components/PersonalData'
import ResponsableData from './components/ResponsableData'
import SelectAllData from './components/SelectAllData'

// @Modals components
import ModalInform from './components/ModalInform'
import ModalAdmin from './components/ModalAdmin'
import ModalResendEmail from './components/ModalResendEmail'
import ModalMobile from './components/ModalMobile'
import ModalResendSms from './components/ModalResendSms'
import ModalMobileDuplicated from './components/ModalMobileDuplicated'

// @Assets
import registerStyle from 'assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx'
import { yupResolver } from '@hookform/resolvers'
import * as Style from './styles'
import Axios from 'axios'

// @Material-ui
import { Grid, TextField, withStyles } from '@material-ui/core'

// @Redux
import { GetGeneralRulesData } from '../../redux/api/generalRules.js'
import { GetPlatformRules } from '../../redux/api/platformRules'
import { GetRegulationData } from '../../redux/api/regulation'

// @Helpers
import { registerFormValidation } from './helpers/validation'
import { validationTreat, initialTreatment } from './helpers/validationTreat'
import { initialFormValues } from './helpers/initialValues'
import { PostUser } from '../../redux/api/user'
import moment from 'moment'

// @Helpers and Utils
import {
	defaultModal,
	defaultProps,
	formatBody,
	GeneralState,
	handleStateRegistration,
	IsStateRegistrationValid,
	onCloseModal,
	replaceCpfCnpj,
} from './helpers/utils'
import {
	GetThemeColorFromStorage,
	GetThemeFromAPI,
} from '../../redux/api/themeColor'
import Modal from './components/Modal'
import ModalDateOfBirthError from './components/ModalDateOfBirthError'
import { envs } from '../../redux/api/windowServerData.js'
import { getProgramTitle } from '../../utils/utils.js'
import { GetContact } from '../../redux/api/footer.js'
import { GetTenantVersion } from '../../redux/api/About.js'
import Documents from './components/Documents/index.js'
import DocumentAlertModal from './components/DocumentAlertModal/index.js'
import DocumentModal from '../../components/DocumentModal/index.js'
import { Box } from '@mui/material'
import Footer from './components/Footer'
import { hideOnEcommerce, isEcommerce } from '../../utils/index.js'

function CreateUser({ classes }) {
	const { push } = useHistory()
	const location = useLocation()
	const { t } = useTranslation()

	const queryParams = new URLSearchParams(window.location.search)
	const token = queryParams.get('token')
	const cpfParams = queryParams.get('cpf')

	const [tenant, setTenant] = useState('')

	const [userCpf, setUserCpf] = useState({})
	const [isCnpj, setIsCnpj] = useState(false)
	const [userData, setUserData] = useState({})
	const [preDisabled, setPreDisabled] = useState(false)
	const [loading, setLoading] = useState(false)
	const [loadingInitial, setLoadingInitial] = useState(false)
	const [smsReceiveNumber, setSmsReceiveNumber] = useState(0)
	const [modalAlert, setModalAlert] = useState(defaultProps)
	const [emancipationStatusInvalid, setEmancipationStatusInvalid] = useState({
		open: false,
		text: '',
	})

	useEffect(() => {
		if (isEcommerce) {
			const sendHeight = () => {
				const height = document.documentElement.scrollHeight
				window.parent.postMessage({ action: 'resize', height }, '*')
			}

			const observer = new ResizeObserver(sendHeight)
			const appRoot = document.getElementById('root') || document.body
			observer.observe(appRoot)
			window.addEventListener('resize', sendHeight)
			sendHeight()

			return () => {
				observer.disconnect()
				window.removeEventListener('resize', sendHeight)
			}
		}
	}, [])
	const [modalRegistration, setModalRegistration] = useState(defaultModal)
	const [modalAlertDocument, setModalAlertDocument] = useState(defaultModal)
	const [generalRules, setGeneralRules] = useState(GeneralState)
	const [ufs, setUfs] = useState()
	const [disableItems, setDisableItems] = useState({
		email: false,
		phone: false,
	})

	const [themeColor, setThemeColor] = useState(GetThemeColorFromStorage())
	const [contact, setContat] = useState()

	const GetContactInfo = async () => {
		const res = await GetContact()
		res && setContat(res)
	}

	const getTheme = async () => {
		try {
			const response = await GetThemeFromAPI()

			if (response?.status === 200 && response?.data) {
				setThemeColor(response.data)
			}
		} catch (error) {
			console.log('Error fetching theme:', error)
		}
	}

	const form = useForm({
		defaultValues: initialFormValues,
		resolver: yupResolver(registerFormValidation),
		mode: 'all',
		criteriaMode: 'firstError',
		shouldFocusError: true,
		shouldUnregister: true,
		context: {
			allowEmancipatedConsumer:
				generalRules?.allowEmancipatedConsumer &&
				userData?.isEmancipated,
			allowSimplifyConsumerRegistration:
				generalRules?.allowSimplifyConsumerRegistration,
		},
	})

	const { cpf } = form.watch()

	useEffect(() => {
		ufs && handleStateRegistration(ufs, form)
	}, [ufs])

	const validateCellPhone = useCallback(async (value, errors) => {
		if (errors?.length) {
			if (errors[0].message === 'cellphonenumber - DUPLICATED')
				setModalAlert((prevState) => ({
					...prevState,
					modalMobileProps: {
						open: true,
						phoneNumber: value.phoneNumber,
						phoneNumber2: value.phoneNumber2,
					},
				}))
		}
	}, [])

	const handleReset = () => {
		setPreDisabled(false)
		setUserCpf({})
		setUfs('')
		form.setValue('dateOfBirth', '')
		form.reset(initialFormValues)
	}

	const getTenantVersion = async () => {
		try {
			const response = await GetTenantVersion()

			if (response?.status === 200 && response?.data) {
				setTenant(response?.data)
			}
		} catch (error) {
			console.log('error', error)
		}
	}

	const UploadImage = async (obj) => {
		setLoading(true)
		try {
			const formData = new FormData()
			formData.append('File', obj)
			const response = await Axios.post(`/Images/UploadFile`, formData, {
				headers: { 'Content-Type': 'multipart/form-data' },
			})

			if (response?.status === 200 && response?.data) {
				form.setValue('emancipatedFile', {
					name: obj?.name || '',
					url: response?.data?.data,
				})
				setModalAlertDocument({
					open: true,
					type: 'document',
					message: t('document_analysis_warning'),
					onConfirm: () => setModalAlertDocument(defaultModal),
				})
				return
			}
			form.setValue(
				'emancipatedFileName',
				initialFormValues.emancipatedFile,
			)
		} catch (error) {
			console.log('error', error)
			form.setValue(
				'emancipatedFileName',
				initialFormValues.emancipatedFile,
			)
		} finally {
			setLoading(false)
		}
	}

	const onSubmit = async (values) => {
		try {
			const stateRegistration = await IsStateRegistrationValid(
				form.watch(),
				setModalRegistration,
				form.watch('isPreRegistration'),
			)

			if (!stateRegistration) return

			const { data: noMask } = await Axios.get(
				`/Consumer/VerifyDocumentNoMask?cpfCnpj=${values.cpf
				}&isSimple=${Boolean(tenant === 'pocketexpress')}`,
				{
					baseURL: envs.REACT_APP_GERMINI_API_URL,
					tenant: Boolean(tenant === 'pocketexpress'),
				},
			)

			let body = formatBody(values, noMask, smsReceiveNumber, isEcommerce)

			const { data, errors, success } = await PostUser(body)

			validateCellPhone(values, errors)

			if (data) {
				localStorage.setItem(
					'consumerSMS',
					JSON.stringify({
						consumer: data,
						expireDate: new Date().getTime() + 900000,
					}),
				)
			}

			validationTreat({
				t,
				data,
				push,
				errors,
				classes,
				success,
				userData,
				preDisabled,
				state: modalAlert,
				setModalAlertDocument,
				setState: setModalAlert,
				isEcommerce,
			})
		} catch (e) {
			console.log(e)
			setModalAlert((prevState) => ({
				...prevState,
				modalInformProps: {
					open: true,
					title: 'Erro ao cadastrar',
					message: e.message,
				},
			}))
		} finally {
			setLoading(false)
		}
	}

	const initializeApp = useCallback(async () => {
		setLoadingInitial(true)
		try {
			await getTheme()

			const [generalRules, platformRules, regulationData] =
				await Promise.all([
					GetGeneralRulesData(),
					GetPlatformRules(),
					GetRegulationData(),
				])

			setGeneralRules({
				...generalRules,
				allowIndications: generalRules.allowIndications,
				corporationPartners: generalRules.hasCorporationPartners,
				useTerms: platformRules.useTerms,
				regulation: regulationData.regulation,
			})

			GetContactInfo()
			getTenantVersion()
		} catch (error) {
			console.error(error)
		} finally {
			setLoadingInitial(false)
		}
	}, [])

	useEffect(() => {
		initializeApp()
		setThemeColor(GetThemeColorFromStorage())
	}, [])

	const handleSendEmail = async () => {
		try {
			let cpf = replaceCpfCnpj(form.watch('cpf'))

			const { data } = await Axios.put(
				`/Consumer/SendEmailConfirmationToken?cpfCnpj=${cpf}`,
				{ baseURL: envs.REACT_APP_GERMINI_API_URL },
			)

			if (data?.success) {
				setModalAlert((prevState) => ({
					...prevState,
					modalResendEmailProps: {
						open: false,
					},
				}))
			}

			initialTreatment({
				errors: data?.errors,
				classes,
				t,
				success: data?.success,
				data: data?.data,
				state: modalAlert,
				setState: setModalAlert,
				push,
			})
		} catch (error) {
			console.log(error)
		}
	}

	const sendSMSActivationCode = async () => {
		let cpf = replaceCpfCnpj(form.watch('cpf'))

		const { data } = await Axios.put(
			`/Consumer/SendSmsActivationCode?cpfCnpj=${cpf}`,
			{
				baseURL: envs.REACT_APP_GERMINI_API_URL,
			},
		)

		localStorage.setItem(
			'consumerSMS',
			JSON.stringify({
				consumer: data.data,
				expireDate: new Date().getTime() + 900000,
			}),
		)

		if (isEcommerce) {
			push(`/confirmRegistration/ecommerce`, {
				userData: data,
			})
		} else
			push(`/ConfirmRegistration`, {
				userData: data,
			})
	}

	const handleLogin = () => {
		if (isEcommerce) {
			push(`/register/ecommerce`)
		} else push(`/auth/login`)
	}

	const handleForgetPWD = () => {
		if (isEcommerce) {
			push(`/register/ecommerce`)
		} else {
			push(`/resetpassword`)
		}
	}

	const handleResetForm = () => {
		setPreDisabled(false)
		setUserCpf({})
		setUserData({})
		setIsCnpj(false)
		setUfs('')
		setSmsReceiveNumber(0)

		form.reset(initialFormValues)

		setModalAlert(defaultProps)
		setModalRegistration(defaultModal)
		setModalAlertDocument(defaultModal)
		setEmancipationStatusInvalid({ open: false, text: '' })
	}

	return loadingInitial ? (
		<Loader />
	) : (
		<form onSubmit={form.handleSubmit(onSubmit)} autoComplete="off">
			{(loading || form.formState.isSubmitting) && <Loader />}

			{modalAlert?.alert && (
				<Box
					sx={{
						'& .btn-lg': {
							bgcolor:
								themeColor?.navigation?.buttons
									?.backgroundColor || '' + '!important',
						},
					}}
				>
					{modalAlert.alert}
				</Box>
			)}
			{emancipationStatusInvalid?.open && (
				<DocumentModal
					{...emancipationStatusInvalid}
					handleClose={() =>
						setEmancipationStatusInvalid({
							...emancipationStatusInvalid,
							open: false,
						})
					}
					themeColor={themeColor}
				/>
			)}
			<Style.Container container>
				<Style.Container
					item
					xs={12}
					sm={12}
					md={isEcommerce ? 12 : 8}
					className="form-container-inner"
					style={isEcommerce ? { height: 'auto', overflowY: 'unset' } : {}}
				>
					<DocumentTitle
						title={getProgramTitle(t('TITLE_REGISTER'))}
					/>
					{/* <Header /> */}
					{hideOnEcommerce(<Header />)}

					<Style.GridBox
						item
						container
						xs={12}
						alignItems="center"
						justifyContent="center"
					>
						<Box width="100%" maxWidth="800px">
							<Controller
								as={<TextField style={{ display: 'none' }} />}
								name="IsError"
								control={form.control}
								id="IsError"
							/>
							<Controller
								as={<TextField style={{ display: 'none' }} />}
								name="InvalidEmail"
								control={form.control}
								id="InvalidEmail"
							/>
							<PersonalData
								{...{
									...form,
									userCpf,
									setUserCpf,
									setModalAlert,
									userData,
									setUserData,
									setPreDisabled,
									preDisabled,
									generalRules,
									isCnpj,
									setIsCnpj,
									ufs,
									setUfs,
									token,
									disableItems,
									setDisableItems,
									tenant,
									cpfParams,
									setEmancipationStatusInvalid,
									themeColor,
								}}
							/>
							{generalRules?.allowEmancipatedConsumer &&
								userData?.isEmancipated && (
									<Documents
										{...{
											...form,
											userCpf,
											preDisabled,
											userData,
											disableItems,
											UploadImage,
										}}
									/>
								)}
							<ContactData
								{...{
									...form,
									userCpf,
									preDisabled,
									userData,
									disableItems,
								}}
							/>

							<AddressData
								{...{
									...form,
									userCpf,
									userData,
									preDisabled,
									setUfs,
									token,
									generalRules,
								}}
							/>

							{replaceCpfCnpj(cpf)?.length > 11 ? (
								<ResponsableData
									{...{
										...form,
										userCpf,
										userData,
										preDisabled,
									}}
								/>
							) : null}
							<AccessData {...{ ...form, userCpf, userData }} />
							{!!generalRules.allowIndications && (
								<IndicationData {...{ ...form, userCpf }} />
							)}
							<SelectAllData
								{...{ ...form, userCpf, generalRules }}
								theme={themeColor}
							/>

							<Style.ButtonBox item xs={12} container>
								<Grid item xs={12}>
									<Box
										component="p"
										p="10px"
										color="#333333"
										sx={{
											font: 'normal normal normal 13px/30px Roboto',
										}}
									>
										{t(
											'FIELD_REGISTER_NOTIFICATION_ACCOUNT_ACTIVATION',
										)}
									</Box>
								</Grid>
								<Grid
									item
									xs={12}
									style={{ paddingBottom: '20px' }}
								>
									<Box
										display="flex"
										justifyContent="center"
										p="10px"
									>
										<Button
											size="sm"
											fullWidth
											defaultTheme={themeColor}
											variant="contained"
											color="greenButtonColor"
											style={{
												maxWidth: '420px',
												backgroundColor: !_.isEmpty(
													form.errors,
												)
													? 'gray'
													: GetThemeColorFromStorage()
														?.navigation?.buttons
														?.backgroundColor,
											}}
											disabled={!_.isEmpty(form.errors)}
											type="submit"
										>
											Cadastrar
										</Button>
									</Box>
								</Grid>
							</Style.ButtonBox>
						</Box>
					</Style.GridBox>
					{/* <Footer /> */}
					<ModalInform
						themeColor={themeColor}
						open={modalAlert?.modalProps?.open}
						text={modalAlert?.modalProps?.text}
						handleLogin={() => handleLogin()}
						handleForgetPWD={() => handleForgetPWD()}
						handleClose={() => {
							handleResetForm()
						}}
					/>

					<ModalAdmin
						open={modalAlert?.modalAdmin?.open}
						text={modalAlert?.modalAdmin?.text}
						handleLogin={() => handleLogin()}
						handleForgetPWD={() => handleForgetPWD()}
						handleClose={() => handleResetForm()}
					/>

					<ModalResendEmail
						t={t}
						open={modalAlert?.modalResendEmailProps?.open}
						email={modalAlert?.modalResendEmailProps?.email}
						minWidth={1200}
						themeColor={themeColor}
						handleSendEmail={() => handleSendEmail()}
						handleClose={() => handleResetForm()}
					/>

					<ModalResendSms
						t={t}
						open={modalAlert?.modalResendSmsProps?.open}
						minWidth={1200}
						themeColor={themeColor}
						handleSendSms={() => sendSMSActivationCode()}
						handleClose={() => handleResetForm()}
					/>

					<ModalMobileDuplicated
						open={modalAlert?.modalMobileProps?.open}
						minWidth={'1200px'}
						maxWidth={'1200px'}
						handleClose={() =>
							setModalAlert((prevState) => ({
								...prevState,
								modalMobileProps: {
									open: false,
									phoneNumber: '',
									phoneNumber2: '',
								},
							}))
						}
						changeModal={true}
						smsReceiveNumber={smsReceiveNumber}
						setSmsReceiveNumber={setSmsReceiveNumber}
						phoneNumber={modalAlert?.modalMobileProps?.phoneNumber}
						phoneNumber2={
							modalAlert?.modalMobileProps?.phoneNumber2
						}
					/>

					<Modal
						open={modalRegistration?.open}
						text={modalRegistration?.message}
						handleClose={() =>
							onCloseModal(setModalRegistration, form)
						}
						themeColor={themeColor}
						type="stateRegister"
					/>

					<DocumentAlertModal
						themeColor={themeColor}
						open={modalAlertDocument?.open}
						text={modalAlertDocument?.message}
						type={modalAlertDocument?.type ?? ''}
						handleClose={() => modalAlertDocument?.onConfirm()}
					/>
					<ModalDateOfBirthError
						t={t}
						open={modalAlert?.modalDateOfBirth?.open}
						text={modalAlert?.modalDateOfBirth?.text}
						contact={contact}
						themeColor={themeColor}
						preDisabled={preDisabled}
						handleResetDate={() => {
							handleReset()
							setModalAlert((prevState) => ({
								...prevState,
								modalDateOfBirth: {
									open: false,
									text: '',
								},
							}))
						}}
					/>

					<ModalMobile
						maxWidth="700px"
						open={modalAlert?.modalError?.open}
						closeByClick={() => {
							handleReset()
							setModalAlert((prevState) => ({
								...prevState,
								modalError: {
									open: false,
									content: '',
								},
							}))
						}}
						themeColor={themeColor}
					>
						<Style.ErrorBox themeColor={themeColor}>
							{modalAlert?.modalError?.content ? (
								modalAlert?.modalError?.content
							) : (
								<p>
									{t(
										'WE_HAVE_IDENTIFIED_THAT_THE_PHONE_NUMBER',
									)}
								</p>
							)}
							<p className="mt-2">
								Contato:{' '}
								<a
									href={`mailto:${contact?.contactEmail}?Subject=Suporte`}
									target="_top"
								>
									{contact?.contactEmail || ''}
								</a>{' '}
								<span>
									{contact?.contactPhoneNumber ||
										contact?.contactPhoneNumber2 ||
										''}
								</span>
							</p>
						</Style.ErrorBox>
					</ModalMobile>
				</Style.Container>
				{hideOnEcommerce(
					<Style.Container item xs={12} sm={12} md={4}>
						<Box maxHeight="100vh" overflow="hidden" height="100%">
							<Footer t={t} contact={contact} />
						</Box>
					</Style.Container>,
				)}
			</Style.Container>
		</form>
	)
}

export default withStyles(registerStyle)(CreateUser)
